module.exports = __webpack_public_path__ + "static/kran01_768-f4fecedbefe53afec747de32641d0cd3.jpg";